import { useGetUserJourney } from '@actions';
import { LoadingSpinner } from '@components/LoadingSpinner/LoadingSpinner';
import { EmptyState, SectionHeading } from '@modules/Admin/Reporting/common';
import JourneyTimeline from '@modules/Admin/UserJourney/JourneyTimeline';
import moment from 'moment';
import { useMemo } from 'react';

const CaseJourney = (props: { studentId: string }) => {
  const { data: journey, isLoading, isError } = useGetUserJourney(props.studentId);

  const { upcoming, past } = useMemo(() => {
    const now = moment();
    const events = journey?.events ?? [];
    return {
      upcoming: events.filter((event) => moment(event.at).isAfter(now)).reverse(),
      past: events.filter((event) => !moment(event.at).isAfter(now)),
    };
  }, [journey]);

  if (isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  if (isError || !journey) {
    return <EmptyState>The journey could not be loaded for this student.</EmptyState>;
  }

  return (
    <div className="flex flex-col gap-8">
      <section className="flex flex-col gap-4">
        <SectionHeading
          title={`Scheduled next (${upcoming.length})`}
          description="Meetings and other items dated in the future, soonest first."
        />
        <JourneyTimeline events={upcoming} groupBy="day" emptyMessage="Nothing scheduled ahead." />
      </section>

      <section className="flex flex-col gap-4">
        <SectionHeading
          title={`History (${past.length})`}
          description={`Newest first, including HubSpot activity. Generated ${moment(
            journey.generatedAt
          ).format('DD MMM YYYY, HH:mm')}.`}
        />
        <JourneyTimeline
          events={past}
          initialHidden={['admin', 'email']}
          emptyMessage="No activity recorded for this student yet."
        />
      </section>
    </div>
  );
};

export default CaseJourney;
